import React from 'react';
import { PlatformWidget } from '@/lib/module-federation';
import { NotificationPlatformFallback } from '@/lib/module-federation/fallback';
import type { INotificationPlatformFallbackProps } from '@/lib/module-federation/fallback/notfication-platform-fallback';

const notificationFallback = {
  default: NotificationPlatformFallback,
  failed: NotificationPlatformFallback,
  isLoading: () => null
};

export const NotificationWidget = (props: INotificationPlatformFallbackProps) => (
  <PlatformWidget
    domain="info"
    placement="notification"
    componentProps={props as any}
    fallback={notificationFallback}
  />
);
